<template>
  <div class="mt-4 mb-8 h-10 w-[400px] max-w-full bg-neutral-50"></div>
  <div class="flex flex-col lg:flex-row gap-4 lg:gap-8 w-full">
    <div class="w-full lg:min-h-[500px] bg-neutral-50 p-4 rounded-lg">
      <div class="p-4 h-full"></div>
    </div>
    <div
      class="w-full lg:w-[500px] lg:flex-none flex flex-col min-gap-2 justify-evenly lg:min-h-[500px] bg-neutral-50 p-4 rounded-lg"
    >
      <div v-for=" in 4" class="p-4 border-b border-[--color-gray-line] last-of-type:border-none"></div>
    </div>
  </div>
</template>
